import { render, staticRenderFns } from "./Historial.vue?vue&type=template&id=444aea2e&scoped=true"
import script from "./Historial.vue?vue&type=script&lang=js"
export * from "./Historial.vue?vue&type=script&lang=js"
import style0 from "./Historial.vue?vue&type=style&index=0&id=444aea2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444aea2e",
  null
  
)

export default component.exports